class SearchVaillantModal {
  constructor(content) {
    this.content = content;
    this.bindSuggestions();
  }

  bindSuggestions() {
    this.content.querySelectorAll('[data-search-suggestion]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.applySuggestion(button.dataset.searchSuggestion);
      });
    });
  }

  applySuggestion(term) {
    if (!term) return;

    const predictiveSearch = this.content.querySelector('predictive-search');
    const input = this.content.querySelector('input[type="search"]');
    if (!input) return;

    input.value = term;
    input.dispatchEvent(new Event('input', { bubbles: true }));

    if (predictiveSearch?.getSearchResults) {
      predictiveSearch.searchTerm = term.trim();
      predictiveSearch.getSearchResults(term.trim());
    }

    input.focus();
  }
}

function initSearchVaillantModals() {
  document.querySelectorAll('.search-modal__content').forEach((content) => {
    if (content.dataset.searchVaillantInit === 'true') return;
    content.dataset.searchVaillantInit = 'true';
    new SearchVaillantModal(content);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearchVaillantModals);
} else {
  initSearchVaillantModals();
}
